import http from 'utils/http';
import {
  getAgentTemplateMoreDataUrl,
  getAllIntegrationsUrl,
  getAvailableToolsUrl,
  getCatalogAvailableToolsUrl,
  getHelpCenterArticleUrl,
  getIntegrationsUrl,
  getIntegrationUrl,
  purchaseCatalogIntegrationUrl
} from './apiUrls';
import {
  AvailableIntegrationResponse,
  ConfigureIntegrationPayload,
  HelpCenterArticleResponse,
  IntegrationToolResponse
} from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getAvailableIntegrations(params?: Record<string, any>): Promise<{
  data: AvailableIntegrationResponse[];
  meta: MetaApiResponse;
}> {
  return http.get(getIntegrationsUrl(), params);
}

export function getAllAvailableIntegrations(params?: Record<string, any>): Promise<{
  data: AvailableIntegrationResponse[];
  meta: MetaApiResponse;
}> {
  return http.get(getAllIntegrationsUrl(), params);
}

export function getAvailableIntegration(id: string): Promise<AvailableIntegrationResponse> {
  return http.get(getIntegrationUrl(id));
}

export function configureIntegration(
  id: string,
  payload: ConfigureIntegrationPayload
): Promise<AvailableIntegrationResponse> {
  return http.put(getIntegrationUrl(id), { available_integration: payload });
}

export function getAvailableTools(id: string): Promise<any[]> {
  return http.get(getAvailableToolsUrl(id));
}

export function getCatalogAvailableTools(code: string): Promise<IntegrationToolResponse[]> {
  return http.get(getCatalogAvailableToolsUrl(code));
}

export function purchaseCatalogIntegration(
  code: string
): Promise<{ data: { id: number; status: string; stripe_invoice_id?: string; invoice_url?: string } }> {
  return http.post(purchaseCatalogIntegrationUrl(code));
}

export function getAgentTemplateMoreData(templateId: number | string): Promise<{ data: string[] }> {
  return http.get(getAgentTemplateMoreDataUrl(), { template_id: templateId });
}

export function getHelpCenterArticle(id: string | number): Promise<HelpCenterArticleResponse> {
  return http.get(getHelpCenterArticleUrl(id));
}
